import { formatTime } from '../utils/formatTime'
import styles from './TimeDisplay.module.css'

interface Props {
  current: number
  duration: number
}

export function TimeDisplay({ current, duration }: Props) {
  if (!duration) {
    return (
      <div className={styles.time}>
        <span>{formatTime(current)}</span>
      </div>
    )
  }
  return (
    <div className={styles.time}>
      <span>{formatTime(current)}</span>
      <span className={styles.sep}> / </span>
      <span>{formatTime(duration)}</span>
    </div>
  )
}
